module.exports = __webpack_public_path__ + "img/amaral_stone_at_the_lin_fong_temple.7b93ae3b.jpg";